<div class="h-100 d-md-none d-sm-block cursor-pointer"
     (click)="showCart()">
  <div class="h-100 d-flex align-items-center justify-content-center flex-column">
    <div class="fw-bold font-xl">{{totalPrice$ | async | currencyFormat: bakeryCurrency}}</div>
    <div class="text-primary font-sm">{{'cart.viewCartDetails' | translate}}</div>
  </div>
</div>